import Circles from './helpers/circles';
import { isVisible } from './helpers/is_visible';

const circles = [];

const initCircles = (el, theme) => {
  const getWidth = () => {
    if (window.innerWidth < 150) {
      return window.innerWidth / 3;
    }

    return 150;
  };

  const getTheme = theme => {
    switch (theme) {
    case 'section__background--primary':
      return ['#ffffff', '#293d50'];
    case 'section__background--secondary':
      return ['#ffffff', '#dca940'];
    case 'section__background--white':
      return ['#293d50', '#dca940'];
    default:
      return ['#ffffff', '#293d50'];
    }
  };

  const circle = Circles.create({
    id:                  el.id,
    value:               el.dataset.value,
    radius:              getWidth(),
    width:               20,
    text:                value => `${value}%`,
    colors:              getTheme(theme),
    duration:            2000,
    wrpClass:            'circles__wrp',
    textClass:           'circles__text',
    valueStrokeClass:    'circles__valueStroke',
    maxValueStrokeClass: 'circles__maxValueStroke',
    styleWrapper:        false,
    styleText:           false
  });

  circles.push(circle);

  window.onresize = () => {
    for (let i = 0; i < circles.length; i++) {
      circles[i].updateRadius(getWidth());
    }
  };
};

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementsByClassName('js__circle-container');

  for (let i = 0; i < container.length; i++) {
    const el = container[i];
    let done;

    window.addEventListener('scroll', () => {
      if (isVisible(el) && !done) {
        const circles = el.getElementsByClassName('js__circle');
        const theme = el.closest('.section__background').classList[1];

        for (let i = 0; i < circles.length; i++) {
          const circle = circles[i];
          initCircles(circle, theme);
        }

        done = true;
      }
    }, false);
  }
});
